<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'

export default {
  page: {
    title: '服務項目',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    Layout,
    BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      products: [...this.merchantProducts],
      category: [...this.serviceCategory],
      filterData: {
        state: '',
        productId: '',
        type: '',
      },
      productTypeList: Object.freeze(productTypeList),
      activeTab: this.$route.params.activeTab || '1',
      tabList: Object.freeze([
        {
          title: '基本設定',
          component: () => lazyLoadComponent(import('./components/TabBasic')),
        },
        {
          title: '一般安親',
          component: () => lazyLoadComponent(import('./components/TabDayCare')),
        },
        {
          title: '加購項目',
          component: () => lazyLoadComponent(import('./components/TabAddition')),
        },
        {
          title: '安親服務問卷',
          component: () => lazyLoadComponent(import('./components/TabQuestionnaire')),
        },
      ]),
      mode: '',
    }
  },
  computed: {
    pageTitle() {
      return this.mode ? (this.mode === 'add' ? `新增${this.tabList[+this.activeTab].title}` : `編輯${this.tabList[+this.activeTab].title}`) : `服務項目`
    },
  },
  watch: {
  },
  created() {
    if (this.$route.params.type === 'service') {
      this.activeTab = '0'
    }
    if (this.$route.params.type === 'addition') {
      this.activeTab = '1'
    }
    if (this.$route.query.tab === 'category') {
      this.activeTab = '2'
    }
  },
  methods: {
    onFilterReset() {
      this.filterData = {
        state: '',
        productId: '',
      }
      this.tryToFetchList()
    },
    updateMode(mode) {
      this.mode = mode
    },
    changeTitle() {
      this.$route.meta.title = this.pageTitle
    },
    async updateCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory')
    }
  },
}
</script>

<template>
  <Layout>
    <el-tabs v-model="activeTab" :class="[mode !== '' ? isEdit : '', $style.headerFixed]" stretch type="border-card" class="isStyleBase">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`">
      </el-tab-pane>
    </el-tabs>
    <div v-for="(tab, index) in tabList" :class="[Number(activeTab) !== 1 ? $style.componentMargin: '']">
      <component :is="tabList[activeTab].component" v-if="Number(activeTab) === index" :merchant-products="products"
        :service-category="category" @update-category="updateCategory" @update-mode="updateMode"
        @changeTitle="changeTitle"></component>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.table {
  @include layer-elevation(5);
}
.componentMargin {
  margin: 15px;
}
:global {
  .isEdit {
    .el-tabs__header {
      display: none;
    }

    &.el-tabs--border-card {
      border-radius: 0;
      background: none;
      box-shadow: none;

      .el-tabs__content {
        padding: 0;
      }
    }
  }
}

</style>
